"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NON_NUMBERS_REGEX = exports.SPECIAL_CHARACTERS_REGEX = void 0;
exports.validate = validate;
exports.getValidationErrors = getValidationErrors;
exports.notEmpty = notEmpty;
exports.lengthNoMoreThan = lengthNoMoreThan;
exports.validEmail = validEmail;
exports.emptyOrEmail = emptyOrEmail;
const lodash_1 = require("lodash");
const validator = __importStar(require("validator"));
async function validate(data, validators, otherErrors) {
    const errors = [...getValidationErrors(data, validators), ...otherErrors];
    return errors.length > 0 ? Promise.reject({ status: 400, validationErrors: errors }) : Promise.resolve();
}
function getValidationErrors(data, validators) {
    const errors = [];
    validators.map((entry) => {
        if (entry.validator) {
            if (entry.field) {
                checkValidator(entry.field, entry.validator, (0, lodash_1.get)(data, entry.field), entry.message, errors);
            }
            else {
                checkValidator('object', entry.validator, data, entry.message, errors);
            }
        }
        else {
            const field = Object.keys(entry)[0];
            checkValidator(field, entry[field], (0, lodash_1.get)(data, field), entry.message, errors);
        }
    });
    return errors;
}
function checkValidator(field, validator, value, message, errors) {
    if (!validator(value)) {
        errors.push({
            field: field,
            message: message || getDefaultMessage(validator),
        });
    }
}
function getDefaultMessage(validator) {
    if (validator === notEmpty)
        return "Can't be blank";
    if (validator === emptyOrEmail || validator === validEmail)
        return 'Invalid email address';
    return 'invalid';
}
function notEmpty(str) {
    return str !== null && str.toString().trim() !== '';
}
function lengthNoMoreThan(field, name, length) {
    return {
        [field]: (value) => !value || value.length <= length,
        message: `${name} cannot be more than ${length} characters`,
    };
}
function validEmail(value) {
    return value && validator.isEmail(value);
}
function emptyOrEmail(value) {
    return !value || validator.isEmail(value);
}
exports.SPECIAL_CHARACTERS_REGEX = /[!@#$%^&*(),.?":{}|<>]/;
exports.NON_NUMBERS_REGEX = /\D/g;
